var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"loading":_vm.loading,"color":"error"},on:{"click":_vm.logout}},'v-btn',_vm.$attrs,false),[_c('v-icon',{staticClass:"mr-1"},[_vm._v("mdi-logout-variant")]),_vm._v(" "+_vm._s(_vm.$t('Logout'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }